import React, { Component } from "react";
import { connect } from "react-redux";
import CustomBoardGiro from "../../../components/CustomBoardGiro";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../components/CustomText";
import Color from "../../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import CustomTextInput from "../../../components/CustomTextInput";
import CustomButton from "../../../components/CustomButton";
import * as selector from "../../../../common/selectors";
import * as enrolGIRONowSelector from "../../../../common/selectors/enrolGIRONow";
import * as enrolGIRONowAction from "../../../../common/actions/enrolGIRONow";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import LoadingOverlay from "../../../components/LoadingOverlay";
import CustomDropDown from "../../../components/CustomDropDown";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { makeStyles } from "@material-ui/core/styles";
import CustomToast from "../../../components/CustomToast";
import CustomEnrolGiroNowV2 from "../../../components/CustomEnrolGiroNowV2";
import CustomPaper from "../../../components/CustomPaper";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Image from "../../../../assets";
import TermsAndConditions from "../TermsAndCondition";

const policyInfo = {
  policyNo: "M0001033",
  productName: "Commercial Motor",
  startDate: "31/08/2020",
  endDate: "30/09/2020",
  renewalPremium: "1,343.15",
};

//  const martialStatus = [
//    { value: 8, label: "DBS/POSB" },
//    { value: 1, label: "Australia & New Zealand Banking Group Limited" },
//    { value: 2, label: "BNP Paribas" },
//    { value: 3, label: "Bank Of China Limited" },
//    { value: 4, label: "The Bank Of Tokyo-Mitsubishi UFJ, Ltd" },
//    { value: 5, label: "CIMB Bank Berhad" },
//    { value: 6, label: "Citibank N.A" },
//    { value: 7, label: "Deutsche Bank AG" },
//   { value: 9, label: "HL Bank" },
//    { value: 10, label: "HSBC Bank (Singapore) Ltd" },
//    { value: 11, label: "HongKong and Shanghai Banking Corporation Limited" },
//    { value: 12, label: "Malayan Banking Berhad" },
//    { value: 13, label: "Mizuho Bank Limited" },
//    { value: 14, label: "Oversea-Chinese Banking Corporation Limited" },
//    { value: 15, label: "RHB Bank Berhad" },
//    { value: 16, label: "Standard Chartered Bank" },
//    { value: 17, label: "Sumitomo Mitsui Banking Corporation" },
//    { value: 18, label: "United Overseas Bank Limited" },
//  ];
const CheckboxWithGreenCheck = withStyles({
  root: {
    "&$checked": {
      "& .MuiIconButton-label": {
        position: "relative",
        zIndex: 0,
      },
      "& .MuiIconButton-label:after": {
        content: '""',
        left: 4,
        top: 4,
        height: 15,
        width: 15,
        position: "absolute",
        backgroundColor: "#424143",
        zIndex: -1,
      },
    },
  },
  checked: {},
})(Checkbox);

class EnrolGiroInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      localPolicyNo: "",
      localOrderNo: "",
      localNric: "",
      localPremium: "",
      localIsRecurring: false,
      localProduct: "",
      localCoveragePeriod: "",
      localStatusLabel: "",
      localMsg: "",
      checkedA: false,
      localShowRecurringCheckBox: false,
      loadingToReddot: false,
      error: false,
      errorMsg: "",
      martialStatus: [
        { value: 8, label: "DBS/POSB" },
        { value: 1, label: "Australia & New Zealand Banking Group Limited" },
        { value: 2, label: "BNP Paribas" },
        { value: 3, label: "Bank Of China Limited" },
        { value: 4, label: "The Bank Of Tokyo-Mitsubishi UFJ, Ltd" },
        { value: 5, label: "CIMB Bank Berhad" },
        { value: 6, label: "Citibank N.A" },
        { value: 7, label: "Deutsche Bank AG" },
        { value: 9, label: "HL Bank" },
        { value: 10, label: "HSBC Bank (Singapore) Ltd" },
        {
          value: 11,
          label: "HongKong and Shanghai Banking Corporation Limited",
        },
        { value: 12, label: "Malayan Banking Berhad" },
        { value: 13, label: "Mizuho Bank Limited" },
        { value: 14, label: "Oversea-Chinese Banking Corporation Limited" },
        { value: 15, label: "RHB Bank Berhad" },
        { value: 16, label: "Standard Chartered Bank" },
        { value: 17, label: "Sumitomo Mitsui Banking Corporation" },
        { value: 18, label: "United Overseas Bank Limited" },
      ],
      bankID: "",
      redirectLoading: false,
      localBankList: [],
      customToastStatus: false,
      toastMessage: "",
      localSubmitErrorCode: null,
      localSubmitErrorMsg: null,
      isVisibleTermsAndCon: false,
      handleCloseTerms: false,
      checkedTerms: false,
      preferredBankCode: "",
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    const ddaPolicyData = enrolGIRONowSelector.getDDAPolicyDataData(
      this.props.getDDAPolicyData
    );
    const policyNumber = enrolGIRONowSelector.getDDAPolicyDataPolicyNumber(
      ddaPolicyData
    );
    const productName = enrolGIRONowSelector.getDDAPolicyDataProductName(
      ddaPolicyData
    );
    const amount = enrolGIRONowSelector.getDDAPolicyDataAmount(ddaPolicyData);
    const preferredBankCode =
      enrolGIRONowSelector.getDDAPolicyDataPreferredBankCode(ddaPolicyData);
    this.setState({
      localPolicyNo: policyNumber,
      localProduct: productName,
      localPremium: amount,
      preferredBankCode: preferredBankCode || "",
    });
    //("policyNumber", this.state.localPolicyNo);

    const { getGIROBankList } = this.props;
    getGIROBankList(1);
    //this.setState({martialStatus:[{value:8,label:"DBS/POSB"}]})
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.createEDDAData !== this.props.createEDDAData) {
      const eddaData = enrolGIRONowSelector.createEDDADataData(
        this.props.createEDDAData
      );
      const dataInside = enrolGIRONowSelector.createEDDADataDataInside(
        eddaData
      );
      const success = enrolGIRONowSelector.createEDDADataSuccess(
        this.props.createEDDAData
      );

      const errorCode = enrolGIRONowSelector.createEDDADataDataInsideErrorCode(
        eddaData
      );
      const errorMsg = enrolGIRONowSelector.createEDDADataDataInsideErrorMsg(
        eddaData
      );
      if (success === false) {
        this.setState({ error: true, errorMsg: dataInside });
        //console.log("errorCode",this.props.createEDDAData.Data.Error_Message)

        const { history } = this.props;
        console.log("errorCode", errorMsg);
        history.push(
          "/GiroStatus" +
            "?" +
            "status=" +
            "failed" +
            "&" +
            "ErrorCode=" +
            this.props.createEDDAData.Data.Error_Code +
            "&" +
            "ErrorMessage=" +
            this.props.createEDDAData.Data.Error_Message
        );
      } else {
        const result = enrolGIRONowSelector.createEDDADataResult(eddaData);
        this.setState({ redirectLoading: true });
        //console.log("dataInside",result)
        if(result === null){
          const { history } = this.props;
          console.log("errorCode", errorMsg);
          history.push(
            "/GiroStatus" +
              "?" +
              "status=" +
              "failed" +
              "&" +
              "ErrorCode=" +
              this.props.createEDDAData.Data.Error_Code +
              "&" +
              "ErrorMessage=" +
              this.props.createEDDAData.Data.Error_Message
          );
        }else{
          window.location.href = result;
        }
       
      }
    }

    if (prevProps.getGIROBankListData !== this.props.getGIROBankListData) {
      const success = enrolGIRONowSelector.getGIROBankListDataSuccess(
        this.props.getGIROBankListData
      );
      const data = enrolGIRONowSelector.getGIROBankListDataData(
        this.props.getGIROBankListData
      );
      if (success === true) {
        //console.log("data", data);
        const { preferredBankCode, bankID } = this.state;
        const matchedPreferredBank =
          preferredBankCode &&
          data &&
          data.find((item) => item.bankCode === preferredBankCode);

        this.setState({
          localBankList: data,
          bankID:
            matchedPreferredBank && (bankID === "" || bankID === 0)
              ? preferredBankCode
              : bankID,
        });
      }
    }
  };

  onClickPayRenewal = () => {};

  onClickLetGo = () => {
    //this.onClickPayRenewal();
    const { createEDDA } = this.props;
    const {
      localPolicyNo,
      localProduct,
      localPremium,
      bankID,
      checkedTerms,
    } = this.state;
    if (this.state.bankID === "") {
      this.setState({
        customToastStatus: true,
        toastMessage: "You must select your preferred bank for GIRO enrolment.",
      });
      return;
    }

    if (this.state.bankID === 0) {
      this.setState({
        customToastStatus: true,
        toastMessage: "You must select your preferred bank for GIRO enrolment.",
      });
      return;
    }

    if (checkedTerms === false) {
      this.setState({
        customToastStatus: true,
        toastMessage: "Please check the Terms and Conditions.",
      });
      return;
    }

    createEDDA(localPolicyNo, localProduct, localPremium, bankID,1);
  };

  onClickHere = () => {
    this.setState({ isVisibleTermsAndCon: true });
  };

  handleChangeCheckedA = (event) => {
    this.setState({ checkedA: event.target.checked });
  };

  onSelectSortBy = (martialStatus) => {
    //console.log("martialStatus", this.state.martialStatus);
    //this.setState({ martialStatus: martialStatus });
  };

  handleChange = (event) => {
    this.setState({ bankID: event.target.value });
  };

  handleCloseTerms = () => {
    this.setState({ isVisibleTermsAndCon: false });
  };

  useOutlinedInputStyles = makeStyles((theme) => ({
    root: {
      "& $notchedOutline": {
        borderColor: "red",
      },
      "&:hover $notchedOutline": {
        borderColor: "blue",
      },
      "&$focused $notchedOutline": {
        borderColor: "green",
      },
    },
    focused: {},
    notchedOutline: {},
  }));

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatus: false });
  };

  termAndConditionModal = () => {
    this.setState({ isVisibleTermsAndCon: true });
  };

  handleChangeCheckedA = () => {
    this.setState({ checkedTerms: !this.state.checkedTerms });
  };

  renderTermAndCondition = () => {
    const { classes } = this.props;
    return (
      <div className={classes.labelTextInputTextStyle}>
        I agree to the{" "}
        <span style={{ color: "#ffc20f" }} onClick={this.termAndConditionModal}>
          {" "}
          Terms And Conditions
        </span>
      </div>
    );
  };

  renderChildren = () => {
    const { classes } = this.props;
    const {
      policyNo,
      productName,
      startDate,
      endDate,
      renewalPremium,
    } = policyInfo;
    const {
      localPolicyNo,
      localOrderNo,
      localNric,
      localPremium,
      localIsRecurring,
      localCoveragePeriod,
      localProduct,
      localStatusLabel,
      localMsg,
      loadingToReddot,
      checkedTerms,
    } = this.state;
    const outlinedInputClasses = this.useOutlinedInputStyles;
    return (
      <CustomPaper
        container
        direction={"column"}
        spacing={2}
        design={classes.paper}
      >
        <Grid item>
          <CustomText
            design={classes.renewNowTextStyle}
            style={{ color: "#424143" }}
          >
            Enrol GIRO payment for your policy
          </CustomText>
        </Grid>

        <Grid item>
          <CustomText
            design={classes.renewNowTextStyleV2}
            style={{ color: "#424143" }}
          >
            Enter the policy number to retrieve details
          </CustomText>
        </Grid>

        <Grid item></Grid>
        <Grid container style={{ marginBottom: 10 }}>
          <Grid item xs={1}></Grid>
          <Grid item xs={10}>
            <CustomTextInput
              title={"Policy Number"}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              value={localPolicyNo}
              disabled={true}
              borderline={false}
            />
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>

        <Grid container style={{ marginBottom: 10 }}>
          <Grid item xs={1}></Grid>
          <Grid item xs={10}>
            <CustomTextInput
              title={"Plan Name"}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              value={localProduct}
              disabled={true}
              borderline={true}
            />
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>

        {/* <Grid item>
          <CustomTextInput
            title={"Policy Name"}
            textstyle={classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth={true}
            value={localProduct}
            disabled={true}
          />
        </Grid> */}
        <Grid container style={{ marginBottom: 10 }}>
          <Grid item xs={1}></Grid>
          <Grid item xs={10}>
            <CustomTextInput
              title={"Premium Amount"}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              // value={`${startDate} ~ ${endDate}`}
              value={localPremium}
              disabled={true}
              borderline={true}
            />
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>
        {/* <Grid item>
          <CustomTextInput
            title={"Premium Amount"}
            textstyle={classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth={true}
            // value={`${startDate} ~ ${endDate}`}
            value={localPremium}
            disabled={true}
          />
        </Grid> */}

        {/* <Grid item>
          <CustomTextInput
            title={"Preferred Bank for GIRO Enrolment"}
            textstyle={classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth={true}
            value={localPremium}
            disabled={true}
          />
        </Grid> */}
        <Grid container style={{ marginBottom: 10 }}>
          <Grid item xs={1}></Grid>
          <Grid item xs={10}>
            <CustomText
              design={classes.labelTextInputTextStyle}
              style={{ marginBottom: 10 }}
            >
              Preferred Bank for GIRO Enrolment
            </CustomText>

            <FormControl
              className={classes.formControl}
              style={{ width: "100%", fontFamily: "Muli" }}
            >
              <Select
                // labelId="demo-simple-select-label"
                // id="demo-simple-select"
                value={this.state.bankID === "" ? 0 : this.state.bankID}
                onChange={this.handleChange}
                style={{ height: 45, fontFamily: "Muli" }}
                placeholder={"DBS/POSB"}
                input={
                  <OutlinedInput
                    labelWidth={"labelWidth"}
                    name="age"
                    id="outlined-age-simple"
                    classes={outlinedInputClasses}
                    autoComplete="new-password"
                    placeholder={"Please Select"}
                  />
                }
              >
                <MenuItem value={0}>Please Select</MenuItem>
                {this.state.localBankList.length > 0
                  ? this.state.localBankList.map((item, index) => {
                      return (
                        <MenuItem value={item.bankCode} key={index}>
                          {item.bankName}
                        </MenuItem>
                      );
                    })
                  : false}
                {/* {this.state.localBankList.map((item, index) => {
                  return (
                    <MenuItem value={item.bankCode} key={index}>
                      {item.bankName}
                    </MenuItem>
                  );
                })} */}
              </Select>
            </FormControl>

            {/* <CustomDropDown
            value={this.state.martialStatus.value}
            options={this.state.martialStatus}
           
            //design={classes.labelTextInputTextStyle}
            //style={{fontWeight:"600",fontSize:18}}
            placeholder={"DBS/POSB"}
            onChange={this.onSelectSortBy}
            //components={<ExpandMoreIcon />}
            //onChange={handleChange}
            //disabled={true}
          /> */}
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>

        <Grid container direction={"row"}>
          <Grid item xs={1}></Grid>
          <Grid item xs={10}>
            <FormControlLabel
              label={this.renderTermAndCondition()}
              control={
                <CheckboxWithGreenCheck
                  classes={{
                    root: classes.a,
                    checked: classes.checked,
                  }}
                  checked={checkedTerms}
                  onChange={this.handleChangeCheckedA}
                />
              }
            />
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>

        {this.state.error === true ? (
          <Grid item xs={12}>
            <CustomText style={{ color: "red" }}>
              {this.state.errorMsg}
            </CustomText>
          </Grid>
        ) : (
          false
        )}

        <Grid container style={{ marginBottom: 10 }}>
          <Grid item xs={4}></Grid>
          <Grid item xs={4}>
            <CustomButton
              title={"Confirm"}
              design={classes.letGoButtonStyle}
              textstyle={classes.buttonTextStyle}
              onClick={this.onClickLetGo}
            />
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>

        <Grid container style={{ marginBottom: 10 }}>
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <CustomText style={{ color: "black", fontWeight: "bold" }}>
              {"By clicking Confirm, you will be redirected to a third-party website to complete your e-GIRO setup."}
            </CustomText>
          </Grid>
        </Grid>

        {/* <Grid item xs={12}>
          <CustomButton
            title={"Confirm"}
            design={classes.letGoButtonStyle}
            textstyle={classes.buttonTextStyle}
            onClick={this.onClickLetGo}
          />
        </Grid> */}

        {this.props.createEDDALoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
        {this.props.getDDAPolicyLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
        {this.state.redirectLoading === true ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
        {this.props.getGIROBankListLoading === true ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
      </CustomPaper>
    );
  };

  render() {
    const { classes } = this.props;
    const { height, width } = this.state;
    return (
      <div className={classes.root}>
        {/* <CustomEnrolGiroNowV2
          children={this.renderChildren()}
          height={height}
          width={width}
        /> */}
        <TermsAndConditions
          isVisible={this.state.isVisibleTermsAndCon}
          handleClose={this.handleCloseTerms}
        />
        {window.innerWidth < 601 ? (
          <CustomEnrolGiroNowV2
            children={this.renderChildren()}
            height={height + 400}
            width={width}
          />
        ) : (
          false
        )}
        {window.innerWidth > 600 ? (
          <AppBar
            position="sticky"
            className={classes.appBar}
            style={{ background: "#333333" }}
          >
            <Toolbar
              className={classes.toolbarStyle}
              style={{
                justifyContent: "space-between",
                //alignItems: "center",
                display: "flex-start",
                flexDirection: "row",
                marginLeft: "5em",
              }}
            >
              <img
                src={Image.nonDirectClientEtiqaLogo}
                style={{ width: 112, height: 60 }}
              />
            </Toolbar>
          </AppBar>
        ) : (
          false
        )}
        {window.innerWidth > 600 ? this.renderChildren() : false}

        {this.props.getGIROBankListLoading === true ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
        <CustomToast
          open={this.state.customToastStatus}
          handleCloseCustomToast={this.handleCloseCustomToast}
          title={this.state.toastMessage}
          warning
        />
      </div>
    );
  }
}

const styles = (theme) => ({
  a: {
    "&$checked": {
      color: "#ffc20f",
    },
    "& .MuiIconButton-label:after": {
      backgroundColor: "red",
    },
  },
  root: {
    flexGrow: 1,
    backgroundColor: "#f4f4f4",
    minHeight: "100vh",
    height: "auto",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    paddingBottom: window.innerWidth < 601 ? 90 : 110,
    // backgroundImage:
    //   window.innerWidth < 601 ? false : `url(${Image.enrolGiroBg})`,
    // backgroundSize: window.innerWidth < 601 ? false : `${screenW} ${screenH}`,
    // backgroundPosition: window.innerWidth < 601 ? false : "bottom center",
    // backgroundRepeat: window.innerWidth < 601 ? false : "no-repeat",
    backgroundImage: `url(${Image.enrolGiroBg})`,
    backgroundSize: window.innerWidth < 601 ? "cover" : "100% auto",
    backgroundPosition: "bottom center",
    backgroundRepeat: "no-repeat",
  },
  bottomImageStyle: {
    width: 20,
    height: 20,
    marginRight: 10,
    color: Color.primaryTextColor,
  },
  labelTextInputTextStyle: {
    ...getFontWeight("400"),
    fontSize: "16px",
    color: "#424143",
    fontFamily: "Muli",
  },
  textInputContainer: {
    height: 45,
    marginTop: 7,
  },
  letGoButtonStyle: {
    //width: 120,
    marginTop: 10,
    //marginBottom:"1em"
  },
  buttonTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  bottomTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    fontFamily: "Muli",
  },
  highLightedTextStyle: {
    color: "#1858b9",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  renewNowTextStyle: {
    fontWeight: "bold",
    fontFamily: "Muli",
    fontSize: 22,
    textAlign: "center",
    marginBottom: 10,
    marginTop: 30,
  },
  renewNowTextStyleV2: {
    ...getFontWeight("400"),
    fontSize: 17,
    textAlign: "center",
    fontFamily: "Muli",
    marginBottom: 45,
  },
  errorTextStyle: {
    color: "red",
  },

  checked: {},
  optTextStyle: {
    fontSize: 13,
    opacity: 0.7,
  },
  paper: {
    // overflow: "auto",
    //backgroundColor: "#f4f4f4",
    //height: "100%",
    marginTop: window.innerWidth < 601 ? 12 : "2.5%",
    marginLeft: "auto",
    marginRight: "auto",
    width: window.innerWidth < 601 ? "calc(100% - 24px)" : "90%",
    maxWidth: 640,
  },
});

function mapStateToProps(state) {
  return {
    createEDDAData: selector.createEDDAData(state),
    createEDDALoading: selector.createEDDALoading(state),
    createEDDAStatus: selector.createEDDAStatus(state),
    getDDAPolicyData: selector.getDDAPolicyData(state),
    getDDAPolicyLoading: selector.getDDAPolicyLoading(state),
    getDDAPolicyStatus: selector.getDDAPolicyStatus(state),
    getGIROBankListData: selector.getGIROBankListData(state),
    getGIROBankListLoading: selector.getGIROBankListLoading(state),
    getGIROBankListStatus: selector.getGIROBankListStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createEDDA: (policyNumber, policyName, premium, bankID,transactionType) =>
      dispatch(
        enrolGIRONowAction.createEDDA(policyNumber, policyName, premium, bankID,transactionType)
      ),
    getGIROBankList: (transactionType) => dispatch(enrolGIRONowAction.getGIROBankList(transactionType)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(EnrolGiroInfo)));
